var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-uppercase border-bold gray-550",attrs:{"color":"primary","outlined":""},on:{"click":_vm.onClick}},[_c('img',{attrs:{"src":"/images/play_icon_blue.svg","width":"25px"}}),_vm._v("\n  Assista ao videocast\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }